<template>
    <div>
        <h1 class="card-title h5">{{ $t('validationForm.headline.title.text') }}</h1>
        <!--<h2 class="card-subtitle h6">Hier können Sie Ihre Gutscheinnummer überprüfen und aktivieren, sowie eine Reservierung durchführen oder Ihren Gutschein umtauschen.</h2>-->
        <form class="form avp-form"
              role="form"
              autocomplete="off"
              @submit.prevent="validate" style="position: relative">
            <p>
                {{ $t('validationForm.supporting_text.intro.text') }}
            </p>
            <div class="form-group form-row align-items-center justify-content-center my-3">
                <div class="col-xs-12 col-sm-9 col-md-8 col-lg-7">
                    <input type="text"
                           ref="code"
                           class="form-control"
                           :placeholder="$t( 'validationForm.form.voucher_code.placeholder' )"
                           aria-describedby="gdpr-notice"
                           v-model="code"
                           required
                           autofocus
                    />
                </div>
                <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
                    <button type="submit"
                            class="btn btn-primary"
                            :disabled="isSubmitting"
                    >
                        {{ $t('validationForm.action.submit.text') }}
                    </button>
                </div>
            </div>
            <i18n path="validationForm.supporting_text.additional_information.text"
                  tag="small"
                  id="gdpr-notice"
                  class="form-text text-muted">
                <a :href=privacyUrl() target="_blank">
                    {{ $t('generic.data_protection') }}
                </a>
            </i18n>

            <div class="captcha" v-if="isCaptchaEnabled()">
                <vue-recaptcha ref="recaptcha"
                               :sitekey="recaptchaKey"
                               size="invisible"
                               :loadRecaptchaScript="true"
                               @verify="onVerify"
                               @expired="onExpired"
                               @error="onError"
                               @render="onRecaptchaRender"
                />
            </div>
        </form>

      <hr/>
      <template v-if="variant.key === 'animod'">
        <p class="text-center text-muted">
          {{ $t('validationForm.headline.novoucher.text') }}
          <br/>{{ $t('validationForm.headline.novoucher.text2', {brand: 'Animod'}) }}
        </p>
        <div class="align-items-center justify-content-center my-3">
          <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
            <a :href=shopUrl() class="btn btn-secondary btn-small">
              {{ $t('validationForm.action.novoucher.text') }}
            </a>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="text-center text-muted">
          Smartbox in Kooperation mit Animod
        </p>
      </template>
    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    import { mapMutations } from 'vuex';
    import variations from "@/mixins/variations";

    export default {
        name: 'VoucherValidationForm',
        components: {
            VueRecaptcha
        },
        mixins: [variations],
        props: ['voucher'],
        data() {
            return {
                codePattern: "",
                captchaToken: null,
                code: this.$route.query.code,
                token: "",
                errors: [],
                promise: null,
                recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
                isSubmitting: false
            }
        },
        methods: {
            ...mapMutations([
                'setLoading'
            ]),
            isCaptchaEnabled() {
                console.log("isCaptchaEnabled()", process.env.VUE_APP_DEBUG_MODE !== "true", !this.$store.state.privilegedClient);
                return process.env.VUE_APP_DEBUG_MODE !== "true" && !this.$store.state.privilegedClient;
            },
            shopUrl() {
                return this.$i18n.t('voucherStatus.action.valuevoucher.link_buy_new.url');
            },
            reset() {
                this.captchaToken = null;
                this.code = "";
                this.errors = [];
                this.isCaptchaEnabled() && this.$refs.recaptcha.reset();
            },
            validateCode() {
                console.log( "Validating voucher format" );
                if ( this.code.match( /^[0-9]{3}-[0-9]{3}-[0-9]{3}$/ ) !== null ) {
                    this.$refs.code.setCustomValidity(this.$i18n.t( 'validationForm.errors.voucher_code_mistaken.text' ));
                    return false;
                }
                return true;
            },
            privacyUrl() {
                return this.$i18n.t( 'validationForm.action.link_privacy.url' );
            },
            async validate() {
                this.isSubmitting = true;

                if (this.validateCode()) {
                    this.$refs.code.setCustomValidity("");

                    //this.setLoading(true);

                    if (!this.captchaToken && this.isCaptchaEnabled()) {
                        console.log('Executing reCaptcha');
                        //when nothing happens look at https://developers.google.com/recaptcha/docs/invisible#programmatic_execute
                        this.$refs.recaptcha.execute();
                        this.isSubmitting = false;
                    }
                    else {
                        this.submit();
                    }
                }
            },
            onVerify( response ) {
                console.log( 'reCaptcha Verified');
                this.captchaToken = response;
                this.submit();
            },
            async submit() {
                const { code, captchaToken } = this;

                try {
                    const voucher = await this.$store.dispatch('validateCode', { code, captchaToken });
                }
                catch(e) {
                    //catching artificial response error, caused by unknown voucher
                }
                finally {
                    this.isSubmitting = false;
                }
            },
            onExpired() {
                console.log( 'reCaptcha Expired' );
                this.setLoading(false);
                this.captchaToken = null;
                this.$refs.recaptcha.reset();
            },
            onError(errors) {
                console.log( 'reCaptcha errors', errors );
                this.setLoading(false);
                console.error(...errors)
            },
            onRecaptchaRender() {
                console.log( 'onRecaptchaRender' );
                if (this.code) {
                    console.log('Code is provided as a query string parameter');
                    this.validate();
                }
            }
        },
        mounted() {
            //console.log("mounted(), captchaEnabled", this.isCaptchaEnabled());
            if (this.isCaptchaEnabled() && this.$refs.recaptcha) {
                console.warn('captcha reset');
                this.$refs.recaptcha.reset();
            }
        },
        created() {
            //console.log("created(), captchaEnabled", this.isCaptchaEnabled());
            this.$store.dispatch('reset');
            if (this.$route.query.token) {
                this.$store.dispatch('fetchBookingDetailsToken', this.$route.query.token);
            }
        }
    }
</script>
